<ion-list>
  <ion-item button (click)="dismiss('add-owner')">
    <ion-label>{{'Add owner' | translate}}</ion-label>
    <ion-icon color="secondary" slot="start" name="person-add"></ion-icon>
  </ion-item>

  @if (authService.authUserSignal()?.role.value > 399) {
    <ion-item button (click)="dismiss('update-league')">
      <ion-label>{{'Update team event' | translate}}</ion-label>
      <ion-icon color="secondary" slot="start" name="person-add"></ion-icon>
    </ion-item>
  }

  <ion-item button (click)="dismiss('settings')">
    <ion-label>{{'Settings' | translate}}</ion-label>
    <ion-icon color="secondary" slot="start" name="settings"></ion-icon>
  </ion-item>
  
  <ion-item button (click)="dismiss('remove-team')" lines="none">
    <ion-label>{{'Allow to remove team' | translate}}</ion-label>
    <ion-icon color="danger" slot="start" name="remove-circle"></ion-icon>
  </ion-item>
  
  @if (isOwner){
    <ion-item button (click)="dismiss('policy')" lines="none">
      <ion-label>{{'Policy' | translate}}</ion-label>
      <ion-icon color="secondary" slot="start" name="people-circle-outline"></ion-icon>
    </ion-item>
  }
</ion-list>